'use strict';
var baseLoginLogin = require('core/login/login');

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var recaptcha = require('core/components/recaptcha');
var toastHelpers = require('core/components/toast');

baseLoginLogin.launchEmailVerificationSentModal = function () {
    if ($('#emailVerificationSentModal').length && $('#emailVerificationSentModal').data('show') === true) {
        $('#emailVerificationSentModal').modal('show');
    }
}

baseLoginLogin.launchVerifiedToast = function () {
    if ($('.login-page').data('verified') == true) {
        var message = $('.login-page').data('verified-message');
        toastHelpers.methods.show('success', message, true);
    }
}

baseLoginLogin.register = function () {
    $('form.registration').submit(function (e) {
        var form = this;
        var $form = $(form);
        var timeout = $form.data('timeout') || 6000; //default timeout (increased on retry)
        var defer = $form.data('defer');

        e.preventDefault();
        // Cancel Ajax
        if ($form.hasClass('csrf-used')) return false;

        // Stop recaptcha promise chain and prevent AJAX
        defer?.state?.() !== 'resolved' && defer?.reject();

        $form.data('defer', recaptcha.check(e, {
            url: $form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            timeout: timeout,
            beforeSend: function ($xhr, settings) {
                $form.addClass('csrf-used');
                $form.data('timeout', timeout * 1.5);
                $form.spinner().start();
            },
            success: function (data) {
                if (data?.success !== true) {
                    $form.trigger('login:register:error', data);
                    formValidation(form, data);
                    $form.spinner().stop();
                    $form.removeClass('csrf-used');

                    setTimeout(function() {
                        var errorfield = $form.find('.is-invalid').first();
                        if (errorfield.length) {
                            var scrollToPosition = errorfield.offset().top - 200;
                            $('html, body').animate({ scrollTop: scrollToPosition});
                        }
                    }, 100);
                } else {
                    $form.trigger('login:register:success', data);
                    location.href = data.redirectOverrideUrl;
                }
            },
            error: function (err) {
                if (err?.responseJSON?.redirectUrl) {
                    location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification($('.error-messaging'), err?.responseJSON?.errorMessage);
                    $form.trigger('login:register:error', err);
                    $form.spinner().stop();
                    $form.removeClass('csrf-used');
                }
            }
        }));

        // Move to after Ajax initialization, still triggered if an AJAX request was started but not if ajax call is malformed
        $form.trigger('login:register', e);
    });
};


module.exports = baseLoginLogin;
